<template>
  <div>
    <div>{{ $t('text.customize_theme_text') }}</div>
    <div class="mb-20">
      <a href="#" class="high-light-color" @click="openCustomThemeDialog()">{{
        $t('text.create_a_custom_theme')
      }}</a>
    </div>
    <div v-loading="loading">
      <div v-for="(colorGroup, index) in colorGroups" :key="index">
        <div v-if="colorGroup.colors.length">
          <div class="color-group-title">{{ colorGroup.title }}</div>
          <el-row :gutter="20" class="color-group-content">
            <el-col
              :xs="24"
              :sm="12"
              :md="6"
              :lg="4"
              v-for="(colorItem, i) in colorGroup.colors"
              :key="i"
            >
              <el-card
                shadow="always"
                :body-style="{ padding: '0px' }"
                class="pointer color-item-card"
                @click.native="selectColor(colorItem)"
                :class="{ active: colorItem.title === selectedColor }"
              >
                <div class="color-item">
                  <div
                    class="color-item-circle"
                    :style="{ backgroundColor: colorItem.topNavTextColor }"
                  ></div>
                  <div
                    class="color-item-header"
                    :style="{ backgroundColor: colorItem.topNavBg }"
                  ></div>
                  <div
                    class="color-item-content"
                    :style="{ backgroundColor: colorItem.contentBg }"
                  >
                    <div
                      class="color-item-sidebar"
                      :style="{
                        backgroundColor: colorItem.leftSidebarBg
                      }"
                    >
                      <span
                        class="color-item-sidebar-active"
                        :style="{
                          backgroundColor: colorItem.sidebarHighlightBg
                        }"
                      ></span>
                    </div>
                    <div class="color-item-content-card">
                      <div
                        class="color-item-content-card-header"
                        :style="{
                          backgroundColor: colorItem.contentCardHeaderBg
                        }"
                      ></div>
                      <div
                        class="color-item-content-card-body"
                        :style="{
                          backgroundColor: colorItem.contentCardBodyBg
                        }"
                      ></div>
                    </div>
                  </div>
                </div>
                <el-radio
                  class="color-selector"
                  v-model="selectedColor"
                  :label="colorItem.title"
                  >{{ colorItem.title }}</el-radio
                >
                <div
                  class="theme-operation"
                  v-if="index === colorGroups.length - 1"
                >
                  <i
                    class="el-icon-edit color-itme-edit-btn"
                    @click.stop="editItem(colorItem)"
                  ></i>
                  <i
                    class="el-icon-close color-item-remove-btn"
                    @click.stop="removeItem(colorItem)"
                  ></i>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <CustomTheme ref="customTheme" />
  </div>
</template>

<script>
import CustomTheme from '@/components/manage/admin/customization/CustomTheme'
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'
import Vue from 'vue'
export default {
  data() {
    return {
      selectedColor: 'Default',
      colorGroups: [
        {
          title: this.$t('text.default_themes'),
          colors: [
            {
              title: 'Default',
              topNavBg: '#fff',
              topNavTextColor: '#98C1D9',
              topNavActiveTextColor: '#98C1D9',
              leftSidebarBg: '#3D5A80',
              sidebarHighlightBg: '#98C1D9',
              sidebarTextColor: '#CECECE',
              sidebarActiveTextColor: '#ffffff',
              contentBg: '#293241',
              contentCardHeaderBg: '#98C1D9',
              contentCardHeaderTextColor: '#ffffff',
              contentCardBodyBg: '#ffffff',
              commonBtnColor: '#3d5a80'
            },
            {
              title: 'Default1',
              topNavBg: '#fff',
              topNavTextColor: '#787A91',
              topNavActiveTextColor: '#787A91',
              leftSidebarBg: '#141E61',
              sidebarHighlightBg: '#787A91',
              sidebarTextColor: '#EEEEEE',
              sidebarActiveTextColor: '#ffffff',
              contentBg: '#0F044C',
              contentCardHeaderBg: '#787A91',
              contentCardHeaderTextColor: '#ffffff',
              contentCardBodyBg: '#ffffff',
              commonBtnColor: '#3d5a80'
            },
            {
              title: 'Default2',
              topNavBg: '#fff',
              topNavTextColor: '#3282B8',
              topNavActiveTextColor: '#3282B8',
              leftSidebarBg: '#0F4C75',
              sidebarHighlightBg: '#3282B8',
              sidebarTextColor: '#CECECE',
              sidebarActiveTextColor: '#ffffff',
              contentBg: '#1B262C',
              contentCardHeaderBg: '#BBE1FA',
              contentCardHeaderTextColor: '#ffffff',
              contentCardBodyBg: '#ffffff',
              commonBtnColor: '#3d5a80'
            },
            {
              title: 'Default3',
              topNavBg: '#fff',
              topNavTextColor: '#4D4C7D',
              topNavActiveTextColor: '#4D4C7D',
              leftSidebarBg: '#4D4C7D',
              sidebarHighlightBg: '#827397',
              sidebarTextColor: '#CECECE',
              sidebarActiveTextColor: '#ffffff',
              contentBg: '#363062',
              contentCardHeaderBg: '#D8B9C3',
              contentCardHeaderTextColor: '#ffffff',
              contentCardBodyBg: '#ffffff',
              commonBtnColor: '#4D4C7D'
            },
            {
              title: 'Default4',
              topNavBg: '#fff',
              topNavTextColor: '#345B63',
              topNavActiveTextColor: '#345B63',
              leftSidebarBg: '#345B63',
              sidebarHighlightBg: '#152D35',
              sidebarTextColor: '#CECECE',
              sidebarActiveTextColor: '#ffffff',
              contentBg: '#D4ECDD',
              contentCardHeaderBg: '#345B63',
              contentCardHeaderTextColor: '#ffffff',
              contentCardBodyBg: '#ffffff',
              commonBtnColor: '#345B63'
            },
            {
              title: 'Default5',
              topNavBg: '#fff',
              topNavTextColor: '#476D7C',
              topNavActiveTextColor: '#476D7C',
              leftSidebarBg: '#254B62',
              sidebarHighlightBg: '#476D7C',
              sidebarTextColor: '#CECECE',
              sidebarActiveTextColor: '#ffffff',
              contentBg: '#1D3E53',
              contentCardHeaderBg: '#77ABB7',
              contentCardHeaderTextColor: '#ffffff',
              contentCardBodyBg: '#ffffff',
              commonBtnColor: '#254B62'
            },
            {
              title: 'Default6',
              topNavBg: '#fff',
              topNavTextColor: '#2a7772',
              topNavActiveTextColor: '#2a7772',
              leftSidebarBg: '#2a7772',
              sidebarHighlightBg: '#004445',
              sidebarTextColor: '#CECECE',
              sidebarActiveTextColor: '#ffffff',
              contentBg: '#011b1d',
              contentCardHeaderBg: '#6fb88e',
              contentCardHeaderTextColor: '#ffffff',
              contentCardBodyBg: '#ffffff',
              commonBtnColor: '#004445'
            },
            {
              title: 'Default7',
              topNavBg: '#fff',
              topNavTextColor: '#45405d',
              topNavActiveTextColor: '#45405d',
              leftSidebarBg: '#2a4150',
              sidebarHighlightBg: '#45405d',
              sidebarTextColor: '#CECECE',
              sidebarActiveTextColor: '#ffffff',
              contentBg: '#2e323c',
              contentCardHeaderBg: '#5b7d86',
              contentCardHeaderTextColor: '#ffffff',
              contentCardBodyBg: '#ffffff',
              commonBtnColor: '#2a4150'
            },
            {
              title: 'Default8',
              topNavBg: '#fff',
              topNavTextColor: '#BF8B67',
              topNavActiveTextColor: '#BF8B67',
              leftSidebarBg: '#9D5353',
              sidebarHighlightBg: '#BF8B67',
              sidebarTextColor: '#CECECE',
              sidebarActiveTextColor: '#ffffff',
              contentBg: '#632626',
              contentCardHeaderBg: '#DACC96',
              contentCardHeaderTextColor: '#ffffff',
              contentCardBodyBg: '#ffffff',
              commonBtnColor: '#9D5353'
            },
            {
              title: 'Default9',
              topNavBg: '#fff',
              topNavTextColor: '#719192',
              topNavActiveTextColor: '#719192',
              leftSidebarBg: '#5F6769',
              sidebarHighlightBg: '#719192',
              sidebarTextColor: '#CECECE',
              sidebarActiveTextColor: '#ffffff',
              contentBg: '#3C4245',
              contentCardHeaderBg: '#719192',
              contentCardHeaderTextColor: '#ffffff',
              contentCardBodyBg: '#ffffff',
              commonBtnColor: '#719192'
            },
            {
              title: 'Default10',
              topNavBg: '#fff',
              topNavTextColor: '#886F6F',
              topNavActiveTextColor: '#886F6F',
              leftSidebarBg: '#886F6F',
              sidebarHighlightBg: '#C1A3A3',
              sidebarTextColor: '#CECECE',
              sidebarActiveTextColor: '#ffffff',
              contentBg: '#F3C5C5',
              contentCardHeaderBg: '#694E4E',
              contentCardHeaderTextColor: '#ffffff',
              contentCardBodyBg: '#ffffff',
              commonBtnColor: '#886F6F'
            },
            {
              title: 'Default11',
              topNavBg: '#fff',
              topNavTextColor: '#414141',
              topNavActiveTextColor: '#414141',
              leftSidebarBg: '#414141',
              sidebarHighlightBg: '#CA3E47',
              sidebarTextColor: '#CECECE',
              sidebarActiveTextColor: '#ffffff',
              contentBg: '#525252',
              contentCardHeaderBg: '#CA3E47',
              contentCardHeaderTextColor: '#ffffff',
              contentCardBodyBg: '#ffffff',
              commonBtnColor: '#414141'
            },
            {
              title: 'Default12',
              topNavBg: '#fff',
              topNavTextColor: '#38598B',
              topNavActiveTextColor: '#38598B',
              leftSidebarBg: '#38598B',
              sidebarHighlightBg: '#A2A8D3',
              sidebarTextColor: '#CECECE',
              sidebarActiveTextColor: '#ffffff',
              contentBg: '#113F67',
              contentCardHeaderBg: '#A2A8D3',
              contentCardHeaderTextColor: '#ffffff',
              contentCardBodyBg: '#ffffff',
              commonBtnColor: '#38598B'
            },
            {
              title: 'Default13',
              topNavBg: '#fff',
              topNavTextColor: '#393E46',
              topNavActiveTextColor: '#393E46',
              leftSidebarBg: '#393E46',
              sidebarHighlightBg: '#B55400',
              sidebarTextColor: '#CECECE',
              sidebarActiveTextColor: '#ffffff',
              contentBg: '#1B435D',
              contentCardHeaderBg: '#B55400',
              contentCardHeaderTextColor: '#ffffff',
              contentCardBodyBg: '#ffffff',
              commonBtnColor: '#393E46'
            },
            {
              title: 'Default14',
              topNavBg: '#fff',
              topNavTextColor: '#393E46',
              topNavActiveTextColor: '#393E46',
              leftSidebarBg: '#393E46',
              sidebarHighlightBg: '#F2A07B',
              sidebarTextColor: '#CECECE',
              sidebarActiveTextColor: '#ffffff',
              contentBg: '#222831',
              contentCardHeaderBg: '#F2A07B',
              contentCardHeaderTextColor: '#ffffff',
              contentCardBodyBg: '#ffffff',
              commonBtnColor: '#393E46'
            },
            {
              title: 'Default15',
              topNavBg: '#fff',
              topNavTextColor: '#8D6262',
              topNavActiveTextColor: '#8D6262',
              leftSidebarBg: '#4D4545',
              sidebarHighlightBg: '#8D6262',
              sidebarTextColor: '#CECECE',
              sidebarActiveTextColor: '#ffffff',
              contentBg: '#393232',
              contentCardHeaderBg: '#ED8D8D',
              contentCardHeaderTextColor: '#ffffff',
              contentCardBodyBg: '#ffffff',
              commonBtnColor: '#4D4545'
            },
            {
              title: 'Default16',
              topNavBg: '#fff',
              topNavTextColor: '#9A9B94',
              topNavActiveTextColor: '#9A9B94',
              leftSidebarBg: '#9A9B94',
              sidebarHighlightBg: '#D4D6C8',
              sidebarTextColor: '#ffffff',
              sidebarActiveTextColor: '#ffffff',
              contentBg: '#52524E',
              contentCardHeaderBg: '#D4D6C8',
              contentCardHeaderTextColor: '#ffffff',
              contentCardBodyBg: '#ffffff',
              commonBtnColor: '#9A9B94'
            },
            {
              title: 'Default17',
              topNavBg: '#fff',
              topNavTextColor: '#393E46',
              topNavActiveTextColor: '#393E46',
              leftSidebarBg: '#393E46',
              sidebarHighlightBg: '#00ADB5',
              sidebarTextColor: '#ECECEC',
              sidebarActiveTextColor: '#ffffff',
              contentBg: '#222831',
              contentCardHeaderBg: '#00ADB5',
              contentCardHeaderTextColor: '#ffffff',
              contentCardBodyBg: '#ffffff',
              commonBtnColor: '#393E46'
            }
          ]
        },
        {
          title: this.$t('text.custom_themes'),
          colors: []
        }
      ],
      loading: false
    }
  },
  components: {
    CustomTheme
  },
  mounted() {
    this.getData()
    if (this.$store.state.customization.colorObjForNewDesign) {
      this.selectedColor = this.$store.state.customization.colorObjForNewDesign.title
    }
  },
  computed: {
    selectedColorObj() {
      let selectedColorObj
      this.colorGroups.forEach(group => {
        group.colors.forEach(color => {
          if (color.title === this.selectedColor) {
            selectedColorObj = color
          }
        })
      })
      return selectedColorObj
    }
  },
  methods: {
    selectColor(item) {
      this.selectedColor = item.title
      this.$store.dispatch(
        'customization/applyColorForNewDesign',
        this.selectedColorObj
      )
      this.$store.dispatch('customization/applyTopNavBg', {
        bg: this.$store.state.customization.topNavBg,
        opacity: this.$store.state.customization.topNavBgOpacity
      })
      this.$store.dispatch('customization/applyMenuBg', {
        bg: this.$store.state.customization.menuBg,
        opacity: this.$store.state.customization.menuBgOpacity
      })
      this.$store.dispatch('customization/applyMainContentBg', {
        bg: this.$store.state.customization.mainContentBg,
        opacity: this.$store.state.customization.mainContentBgOpacity
      })
    },
    openCustomThemeDialog() {
      this.$refs.customTheme.openDialog()
    },
    getData() {
      this.loading = true
      ApiService.GetAllThemes().then(response => {
        this.loading = false
        if (response.data.success) {
          let customThemes = response.data.data
            .map(item => {
              return {
                ...JSON.parse(item.Value).colors,
                id: item.Id
              }
            })
            .filter(item => {
              // Distinguish whether it is the theme of the new design
              return item.topNavBg
            })
          Vue.set(this.colorGroups, this.colorGroups.length - 1, {
            ...this.colorGroups[this.colorGroups.length - 1],
            colors: customThemes
          })
        } else {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed'),
            text: response.data.msg
          })
        }
      })
    },
    removeItem(item) {
      let warningIconUrl = require('@/assets/image/warning-icon/warning.svg')
      this.$confirm(
        `<div class='warning-content'>${this.$t(
          'text.delete_theme_warning'
        )}</div><img class='warning-icon' src=${warningIconUrl}>`,
        this.$t('text.you_able_to_delete_data') + ' ' + item.title,
        {
          confirmButtonText: this.$t('text.delete').toUpperCase(),
          cancelButtonText: this.$t('text.cancel').toUpperCase(),
          confirmButtonClass: 'confirm-btn',
          cancelButtonClass: 'cancel-btn',
          type: 'warning',
          customClass: 'delete-warning-box',
          showClose: true,
          closeOnClickModal: false,
          dangerouslyUseHTMLString: true
        }
      )
        .then(() => {
          this.handleRemove(item)
        })
        .catch(() => {})
    },
    handleRemove(item) {
      this.loading = true
      ApiService.DeleteCustomTheme(item.id).then(response => {
        this.loading = false
        if (response.data.success) {
          this.getData()
        } else {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed'),
            text: response.data.msg
          })
        }
      })
    },
    editItem(item) {
      this.$refs.customTheme.openDialog(item)
    }
  }
}
</script>

<style lang="scss" scoped>
.color-item-card {
  position: relative;
  margin-bottom: 10px;
  &.active {
    background: rgb(227, 243, 249);
    border: 1px solid rgb(18, 98, 160);
  }
}
.color-group-title {
  margin: 5px 0;
}
.color-group-content {
  margin-bottom: 20px;
}
.color-item {
  width: 100%;
  position: relative;
  .color-item-circle {
    width: 20px;
    height: 20px;
    border-radius: 10px;
    position: absolute;
    right: 10px;
    top: 5px;
    border: 1px solid white;
  }
  .color-item-header {
    height: 30px;
  }
  .color-item-content {
    height: 100px;
    display: flex;
    .color-item-sidebar {
      width: 25%;
      height: 100%;
      display: inline-block;
      .color-item-sidebar-active {
        display: inline-block;
        width: 100%;
        height: 20px;
        margin-top: 40px;
      }
    }
    .color-item-content-card {
      width: 75%;
      height: 100%;
      padding: 10px;
      display: inline-block;
      .color-item-content-card-header {
        height: 20px;
      }
      .color-item-content-card-body {
        height: calc(100% - 20px);
      }
    }
  }
}
.theme-operation {
  display: inline-block;
  position: absolute;
  right: 5px;
  bottom: 10px;
  font-size: 20px;
  .color-itme-edit-btn {
    cursor: pointer;
    color: #02a7f0;
    &:hover {
      font-weight: bold;
    }
  }
  .color-item-remove-btn {
    cursor: pointer;
    color: rgba(217, 0, 27, 1);
    margin-left: 5px;
    &:hover {
      font-weight: bold;
    }
  }
}
.color-selector {
  margin: 15px;
  .el-radio__input.is-checked + .el-radio__label {
    color: #606266;
  }
}
</style>
